var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddDeviceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 87,
    viewBox: "0 0 96 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8765",
    "data-name": "Group 8765",
    transform: "translate(-1565 -931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_67_66",
    "data-name": "Component 67 \\u2013 66",
    transform: "translate(1565 931)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4338",
    "data-name": "Rectangle 4338",
    width: 73,
    height: 73,
    rx: 8,
    fill: "#ffd500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_8878",
    "data-name": "Path 8878",
    transform: "translate(1585 942.938)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.60858535766602 44.67674255371094 L 11.33629894256592 42.65142822265625 L 11.31265926361084 42.64917755126953 L 11.28890895843506 42.64917755126953 C 8.348978996276855 42.64917755126953 5.585019111633301 41.50430679321289 3.506179094314575 39.42546844482422 C 1.427329063415527 37.34661865234375 0.2824590504169464 34.58265686035156 0.2824590504169464 31.64272689819336 L 0.2824590504169464 31.58072662353516 L 0.2673190534114838 31.52060699462891 L -4.738888263702393 11.64364910125732 C -4.106396675109863 10.95097064971924 -1.843010187149048 8.523479461669922 0.9509290456771851 6.125407218933105 C 5.238608837127686 2.445227146148682 8.81342887878418 0.4999971389770508 11.28890895843506 0.4999971389770508 L 31.42518997192383 0.4999971389770508 C 34.36511993408203 0.4999971389770508 37.12907791137695 1.644867181777954 39.20792770385742 3.72370719909668 C 41.28676986694336 5.802556991577148 42.431640625 8.566516876220703 42.431640625 11.50644683837891 L 42.431640625 31.64272689819336 C 42.431640625 37.25775146484375 33.84917449951172 43.76578521728516 32.60858535766602 44.67674255371094 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.28890991210938 0.9999961853027344 C 9.648319244384766 0.9999961853027344 6.580978393554688 1.95379638671875 1.284889221191406 6.497688293457031 C -1.270263671875 8.689933776855469 -3.380283355712891 10.90930938720703 -4.188117980957031 11.78323745727539 L 0.7824592590332031 31.51873779296875 L 0.7824592590332031 31.64272689819336 C 0.7824592590332031 37.43600845336914 5.495628356933594 42.14917755126953 11.28890991210938 42.14917755126953 L 11.3364086151123 42.14917755126953 L 32.46573257446289 44.1608772277832 C 33.19811630249023 43.61569595336914 35.18651962280273 42.08000946044922 37.14764022827148 40.07887649536133 C 40.27735900878906 36.88530731201172 41.931640625 33.96813583374023 41.931640625 31.64272689819336 L 41.931640625 11.50644683837891 C 41.931640625 5.713165283203125 37.21846771240234 0.9999961853027344 31.42518997192383 0.9999961853027344 L 11.28890991210938 0.9999961853027344 M 11.28890991210938 -3.814697265625e-06 L 31.42518997192383 -3.814697265625e-06 C 37.780029296875 -3.814697265625e-06 42.931640625 5.151607513427734 42.931640625 11.50644683837891 L 42.931640625 31.64272689819336 C 42.931640625 37.99756622314453 32.74925994873047 45.19239807128906 32.74925994873047 45.19239807128906 L 11.28890991210938 43.14917755126953 C 4.934070587158203 43.14917755126953 -0.2175407409667969 37.99756622314453 -0.2175407409667969 31.64272689819336 L -5.2890625 11.50644683837891 C -5.2890625 11.50644683837891 4.934070587158203 -3.814697265625e-06 11.28890991210938 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#ffd500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4349",
    "data-name": "Rectangle 4349",
    transform: "translate(1578 947)",
    fill: "#fff",
    stroke: "#ffd500",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4350",
    "data-name": "Rectangle 4350",
    transform: "translate(1586 956)",
    fill: "#fff",
    stroke: "#ffd500",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 9,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 8,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4351",
    "data-name": "Rectangle 4351",
    transform: "translate(1586 970)",
    fill: "#fff",
    stroke: "#ffd500",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4356",
    "data-name": "Rectangle 4356",
    transform: "translate(1612 970)",
    fill: "#fff",
    stroke: "#ffd500",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4352",
    "data-name": "Rectangle 4352",
    transform: "translate(1586 975)",
    fill: "#fff",
    stroke: "#ffd500",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4355",
    "data-name": "Rectangle 4355",
    transform: "translate(1612 975)",
    fill: "#fff",
    stroke: "#ffd500",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4353",
    "data-name": "Rectangle 4353",
    transform: "translate(1593 980)",
    fill: "#fff",
    stroke: "#ffd500",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4354",
    "data-name": "Rectangle 4354",
    transform: "translate(1612 980)",
    fill: "#fff",
    stroke: "#ffd500",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_navigation_close_24px",
    "data-name": "icon/navigation/close_24px",
    transform: "translate(1618 975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4339",
    "data-name": "Rectangle 4339",
    fill: "#f6f6f6",
    stroke: "#545454",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 41,
    height: 41,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 33,
    height: 33,
    transform: "translate(5 5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M20.364,2.051,18.313,0,10.182,8.131,2.051,0,0,2.051l8.131,8.131L0,18.313l2.051,2.051,8.131-8.131,8.131,8.131,2.051-2.051-8.131-8.131Z",
    transform: "translate(21.5 7.101) rotate(45)",
    fill: "#787878"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDeviceIcon);
export default __webpack_public_path__ + "static/media/AddDeviceIcon.4980a0702a39bf9ac2793828614a90f4.svg";
export { ForwardRef as ReactComponent };